import { Clickable, Icon, Sidepanel } from 'components';
import React, { useState } from 'react';
import { CreateUser } from 'screens/Admin/components';

const CreateUserPanel = ({ userIdx, onCreate, marg, dimensions }) => {
  const [visible, setVisible] = useState(false);

  function handleVisible() {
    setVisible(!visible);
  }

  return (
    <React.Fragment>
      <Clickable marg={marg} onClick={handleVisible}>
        <Icon type="add" dimensions={dimensions} />
      </Clickable>

      <Sidepanel visible={visible} closeModal={handleVisible}>
        <CreateUser callback={onCreate} />
      </Sidepanel>
    </React.Fragment>
  );
};

export default CreateUserPanel;
